/* eslint-disable */
const azureConfig = {
  authorityDomain: "b2cdelaval.b2clogin.com",
  azureClientId: "b530c7a7-41e6-481f-8b4b-b8284423a2aa",
  signUpSignIn: {
    authority: "https://b2cdelaval.b2clogin.com/B2CDeLaval.onmicrosoft.com/B2C_1A_AWSUSERMIG_SIGNUPORSIGNIN"
  },
};
export default azureConfig;
